export enum ZipYiContext {
  Loading = 'GC_LOADING',
  HomePage = 'GC_HOME',
  CheckoutPage = 'GC_CHECKOUT',
  CreateCheckoutPage = 'GC_CREATE_CHECKOUT',
  PurchaseCompletePage = 'GC_PURCHASE_COMPLETE',
  PurchasePendingPage = 'GC_PURCHASE_PENDING',
  GeneralErrorPage = 'GC_GENERAL_ERROR',
  UnavailableErrorPage = 'GC_UNAVAILABLE_ERROR',
  ZipMoneyOnlyCashbackModal = 'GC_ZM_ONLY_CASHBACK_DIALOG',
  ApplyForZipMoneyModal = 'GC_APPLY_FOR_ZM_DIALOG',
}
